'use client'
import { FC, ReactNode } from 'react'
import { useTrackPageView } from 'storefront-modules/third-party'

interface AppComponentProps {
  children: ReactNode
}

const AppComponent: FC<AppComponentProps> = ({ children }) => {
  useTrackPageView()

  return <>{children}</>
}

export default AppComponent
